import { TCountryRiskLevel } from 'DesignSystem/DataDisplay/CountryRiskLevel/CountryRiskLevel';

export const COUNTRIES: {
  code: string;
  label: string;
  phone: string;
  isInEU: boolean;
  riskLevel?: TCountryRiskLevel;
}[] = [
  { code: 'AD', label: 'Andorra', phone: '376', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'AE',
    label: 'United Arab Emirates',
    phone: '971',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'AF', label: 'Afghanistan', phone: '93', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'AG',
    label: 'Antigua and Barbuda',
    phone: '1-268',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'AI', label: 'Anguilla', phone: '1-264', isInEU: false, riskLevel: 'LOW' },
  { code: 'AL', label: 'Albania', phone: '355', isInEU: false, riskLevel: 'LOW' },
  { code: 'AM', label: 'Armenia', phone: '374', isInEU: false, riskLevel: 'LOW' },
  { code: 'AO', label: 'Angola', phone: '244', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'AQ', label: 'Antarctica', phone: '672', isInEU: false, riskLevel: 'LOW' },
  { code: 'AR', label: 'Argentina', phone: '54', isInEU: false, riskLevel: 'MEDIUM' },
  {
    code: 'AS',
    label: 'American Samoa',
    phone: '1-684',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'AT', label: 'Austria', phone: '43', isInEU: true, riskLevel: 'LOW' },
  {
    code: 'AU',
    label: 'Australia',
    phone: '61',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'AW', label: 'Aruba', phone: '297', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'AX',
    label: 'Alland Islands',
    phone: '358',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'AZ', label: 'Azerbaijan', phone: '994', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'BA',
    label: 'Bosnia and Herzegovina',
    phone: '387',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'BB', label: 'Barbados', phone: '1-246', isInEU: false, riskLevel: 'LOW' },
  { code: 'BD', label: 'Bangladesh', phone: '880', isInEU: false, riskLevel: 'LOW' },
  { code: 'BE', label: 'Belgium', phone: '32', isInEU: true, riskLevel: 'LOW' },
  {
    code: 'BF',
    label: 'Burkina Faso',
    phone: '226',
    isInEU: false,
    riskLevel: 'MEDIUM',
  },
  { code: 'BG', label: 'Bulgaria', phone: '359', isInEU: true, riskLevel: 'LOW' },
  { code: 'BH', label: 'Bahrain', phone: '973', isInEU: false, riskLevel: 'LOW' },
  { code: 'BI', label: 'Burundi', phone: '257', isInEU: false, riskLevel: 'LOW' },
  { code: 'BJ', label: 'Benin', phone: '229', isInEU: false, riskLevel: 'MEDIUM' },
  {
    code: 'BL',
    label: 'Saint Barthelemy',
    phone: '590',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'BM', label: 'Bermuda', phone: '1-441', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'BN',
    label: 'Brunei Darussalam',
    phone: '673',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'BO', label: 'Bolivia', phone: '591', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'BR', label: 'Brazil', phone: '55', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'BS', label: 'Bahamas', phone: '1-242', isInEU: false, riskLevel: 'LOW' },
  { code: 'BT', label: 'Bhutan', phone: '975', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'BV',
    label: 'Bouvet Island',
    phone: '47',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'BW', label: 'Botswana', phone: '267', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'BY', label: 'Belarus', phone: '375', isInEU: false, riskLevel: 'HIGH' },
  { code: 'BZ', label: 'Belize', phone: '501', isInEU: false, riskLevel: 'MEDIUM' },
  {
    code: 'CA',
    label: 'Canada',
    phone: '1',

    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'CC',
    label: 'Cocos (Keeling) Islands',
    phone: '61',
    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'CD',
    label: 'Congo, Democratic Republic of the',
    phone: '243',
    isInEU: false,
    riskLevel: 'MEDIUM',
  },
  {
    code: 'CF',
    label: 'Central African Republic',
    phone: '236',
    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'CG',
    label: 'Congo, Republic of the',
    phone: '242',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'CH', label: 'Switzerland', phone: '41', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'CK',
    label: 'Cook Islands',
    phone: '682',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'CL', label: 'Chile', phone: '56', isInEU: false, riskLevel: 'LOW' },
  { code: 'CM', label: 'Cameroon', phone: '237', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'CN', label: 'China', phone: '86', isInEU: false, riskLevel: 'LOW' },
  { code: 'CO', label: 'Colombia', phone: '57', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'CR', label: 'Costa Rica', phone: '506', isInEU: false, riskLevel: 'LOW' },
  { code: 'CU', label: 'Cuba', phone: '53', isInEU: false, riskLevel: 'LOW' },
  { code: 'CV', label: 'Cape Verde', phone: '238', isInEU: false, riskLevel: 'LOW' },
  { code: 'CW', label: 'Curacao', phone: '599', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'CX',
    label: 'Christmas Island',
    phone: '61',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'CY', label: 'Cyprus', phone: '357', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'CZ',
    label: 'Czech Republic',
    phone: '420',
    isInEU: true,
    riskLevel: 'LOW',
  },
  {
    code: 'DE',
    label: 'Germany',
    phone: '49',

    isInEU: true,
    riskLevel: 'LOW',
  },
  { code: 'DJ', label: 'Djibouti', phone: '253', isInEU: false, riskLevel: 'LOW' },
  { code: 'DK', label: 'Denmark', phone: '45', isInEU: true, riskLevel: 'LOW' },
  { code: 'DM', label: 'Dominica', phone: '1-767', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'DO',
    label: 'Dominican Republic',
    phone: '1-809',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'DZ', label: 'Algeria', phone: '213', isInEU: false, riskLevel: 'LOW' },
  { code: 'EC', label: 'Ecuador', phone: '593', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'EE', label: 'Estonia', phone: '372', isInEU: true, riskLevel: 'LOW' },
  { code: 'EG', label: 'Egypt', phone: '20', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'EH',
    label: 'Western Sahara',
    phone: '212',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'ER', label: 'Eritrea', phone: '291', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'ES', label: 'Spain', phone: '34', isInEU: true, riskLevel: 'LOW' },
  { code: 'ET', label: 'Ethiopia', phone: '251', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'FI', label: 'Finland', phone: '358', isInEU: true, riskLevel: 'LOW' },
  { code: 'FJ', label: 'Fiji', phone: '679', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'FK',
    label: 'Falkland Islands (Malvinas)',
    phone: '500',
    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'FM',
    label: 'Micronesia, Federated States of',
    phone: '691',
    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'FO',
    label: 'Faroe Islands',
    phone: '298',
    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'FR',
    label: 'France',
    phone: '33',

    isInEU: true,
    riskLevel: 'LOW',
  },
  { code: 'GA', label: 'Gabon', phone: '241', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'GB',
    label: 'United Kingdom',
    phone: '44',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'GD', label: 'Grenada', phone: '1-473', isInEU: false, riskLevel: 'LOW' },
  { code: 'GE', label: 'Georgia', phone: '995', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'GF',
    label: 'French Guiana',
    phone: '594',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'GG', label: 'Guernsey', phone: '44', isInEU: false, riskLevel: 'LOW' },
  { code: 'GH', label: 'Ghana', phone: '233', isInEU: false, riskLevel: 'LOW' },
  { code: 'GI', label: 'Gibraltar', phone: '350', isInEU: false, riskLevel: 'LOW' },
  { code: 'GL', label: 'Greenland', phone: '299', isInEU: false, riskLevel: 'LOW' },
  { code: 'GM', label: 'Gambia', phone: '220', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'GN', label: 'Guinea', phone: '224', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'GP', label: 'Guadeloupe', phone: '590', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'GQ',
    label: 'Equatorial Guinea',
    phone: '240',
    isInEU: false,
    riskLevel: 'MEDIUM',
  },
  { code: 'GR', label: 'Greece', phone: '30', isInEU: true, riskLevel: 'LOW' },
  {
    code: 'GT',
    label: 'Guatemala',
    phone: '502',
    isInEU: false,
    riskLevel: 'MEDIUM',
  },
  { code: 'GU', label: 'Guam', phone: '1-671', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'GW',
    label: 'Guinea-Bissau',
    phone: '245',
    isInEU: false,
    riskLevel: 'MEDIUM',
  },
  { code: 'GY', label: 'Guyana', phone: '592', isInEU: false, riskLevel: 'LOW' },
  { code: 'HK', label: 'Hong Kong', phone: '852', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'HM',
    label: 'Heard Island and McDonald Islands',
    phone: '672',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'HN', label: 'Honduras', phone: '504', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'HR', label: 'Croatia', phone: '385', isInEU: true, riskLevel: 'LOW' },
  { code: 'HT', label: 'Haiti', phone: '509', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'HU', label: 'Hungary', phone: '36', isInEU: true, riskLevel: 'LOW' },
  { code: 'ID', label: 'Indonesia', phone: '62', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'IE', label: 'Ireland', phone: '353', isInEU: true, riskLevel: 'LOW' },
  { code: 'IL', label: 'Israel', phone: '972', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'IM', label: 'Isle of Man', phone: '44', isInEU: false, riskLevel: 'LOW' },
  { code: 'IN', label: 'India', phone: '91', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'IO',
    label: 'British Indian Ocean Territory',
    phone: '246',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'IQ', label: 'Iraq', phone: '964', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'IR',
    label: 'Iran, Islamic Republic of',
    phone: '98',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'IS', label: 'Iceland', phone: '354', isInEU: false, riskLevel: 'LOW' },
  { code: 'IT', label: 'Italy', phone: '39', isInEU: true, riskLevel: 'LOW' },
  { code: 'JE', label: 'Jersey', phone: '44', isInEU: false, riskLevel: 'LOW' },
  { code: 'JM', label: 'Jamaica', phone: '1-876', isInEU: false, riskLevel: 'LOW' },
  { code: 'JO', label: 'Jordan', phone: '962', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'JP',
    label: 'Japan',
    phone: '81',

    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'KE', label: 'Kenya', phone: '254', isInEU: false, riskLevel: 'LOW' },
  { code: 'KG', label: 'Kyrgyzstan', phone: '996', isInEU: false, riskLevel: 'LOW' },
  { code: 'KH', label: 'Cambodia', phone: '855', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'KI', label: 'Kiribati', phone: '686', isInEU: false, riskLevel: 'LOW' },
  { code: 'KM', label: 'Comoros', phone: '269', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'KN',
    label: 'Saint Kitts and Nevis',
    phone: '1-869',
    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'KR',
    label: 'Korea, Republic of',
    phone: '82',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'KW', label: 'Kuwait', phone: '965', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'KY',
    label: 'Cayman Islands',
    phone: '1-345',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'KZ', label: 'Kazakhstan', phone: '7', isInEU: false, riskLevel: 'LOW' },
  { code: 'LB', label: 'Lebanon', phone: '961', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'LC',
    label: 'Saint Lucia',
    phone: '1-758',
    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'LI',
    label: 'Liechtenstein',
    phone: '423',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'LK', label: 'Sri Lanka', phone: '94', isInEU: false, riskLevel: 'LOW' },
  { code: 'LR', label: 'Liberia', phone: '231', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'LS', label: 'Lesotho', phone: '266', isInEU: false, riskLevel: 'LOW' },
  { code: 'LT', label: 'Lithuania', phone: '370', isInEU: true, riskLevel: 'LOW' },
  { code: 'LU', label: 'Luxembourg', phone: '352', isInEU: true, riskLevel: 'LOW' },
  { code: 'LV', label: 'Latvia', phone: '371', isInEU: true, riskLevel: 'LOW' },
  { code: 'LY', label: 'Libya', phone: '218', isInEU: false, riskLevel: 'LOW' },
  { code: 'MA', label: 'Morocco', phone: '212', isInEU: false, riskLevel: 'LOW' },
  { code: 'MC', label: 'Monaco', phone: '377', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'MD',
    label: 'Moldova, Republic of',
    phone: '373',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'ME', label: 'Montenegro', phone: '382', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'MF',
    label: 'Saint Martin (French part)',
    phone: '590',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'MG', label: 'Madagascar', phone: '261', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'MH',
    label: 'Marshall Islands',
    phone: '692',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'ML', label: 'Mali', phone: '223', isInEU: false, riskLevel: 'LOW' },
  { code: 'MM', label: 'Myanmar', phone: '95', isInEU: false, riskLevel: 'HIGH' },
  { code: 'MN', label: 'Mongolia', phone: '976', isInEU: false, riskLevel: 'LOW' },
  { code: 'MO', label: 'Macao', phone: '853', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'MP',
    label: 'Northern Mariana Islands',
    phone: '1-670',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'MQ', label: 'Martinique', phone: '596', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'MR',
    label: 'Mauritania',
    phone: '222',
    isInEU: false,
    riskLevel: 'MEDIUM',
  },
  {
    code: 'MS',
    label: 'Montserrat',
    phone: '1-664',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'MT', label: 'Malta', phone: '356', isInEU: true, riskLevel: 'LOW' },
  { code: 'MU', label: 'Mauritius', phone: '230', isInEU: false, riskLevel: 'LOW' },
  { code: 'MV', label: 'Maldives', phone: '960', isInEU: false, riskLevel: 'LOW' },
  { code: 'MW', label: 'Malawi', phone: '265', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'MX', label: 'Mexico', phone: '52', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'MY', label: 'Malaysia', phone: '60', isInEU: false, riskLevel: 'MEDIUM' },
  {
    code: 'MZ',
    label: 'Mozambique',
    phone: '258',
    isInEU: false,
    riskLevel: 'MEDIUM',
  },
  { code: 'NA', label: 'Namibia', phone: '264', isInEU: false, riskLevel: 'MEDIUM' },
  {
    code: 'NC',
    label: 'New Caledonia',
    phone: '687',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'NE', label: 'Niger', phone: '227', isInEU: false, riskLevel: 'MEDIUM' },
  {
    code: 'NF',
    label: 'Norfolk Island',
    phone: '672',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'NG', label: 'Nigeria', phone: '234', isInEU: false, riskLevel: 'MEDIUM' },
  {
    code: 'NI',
    label: 'Nicaragua',
    phone: '505',
    isInEU: false,
    riskLevel: 'MEDIUM',
  },
  { code: 'NL', label: 'Netherlands', phone: '31', isInEU: true, riskLevel: 'LOW' },
  { code: 'NO', label: 'Norway', phone: '47', isInEU: false, riskLevel: 'LOW' },
  { code: 'NP', label: 'Nepal', phone: '977', isInEU: false, riskLevel: 'LOW' },
  { code: 'NR', label: 'Nauru', phone: '674', isInEU: false, riskLevel: 'LOW' },
  { code: 'NU', label: 'Niue', phone: '683', isInEU: false, riskLevel: 'LOW' },
  { code: 'NZ', label: 'New Zealand', phone: '64', isInEU: false, riskLevel: 'LOW' },
  { code: 'OM', label: 'Oman', phone: '968', isInEU: false, riskLevel: 'LOW' },
  { code: 'PA', label: 'Panama', phone: '507', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'PE', label: 'Peru', phone: '51', isInEU: false, riskLevel: 'MEDIUM' },
  {
    code: 'PF',
    label: 'French Polynesia',
    phone: '689',
    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'PG',
    label: 'Papua New Guinea',
    phone: '675',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'PH', label: 'Philippines', phone: '63', isInEU: false, riskLevel: 'LOW' },
  { code: 'PK', label: 'Pakistan', phone: '92', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'PL', label: 'Poland', phone: '48', isInEU: true, riskLevel: 'LOW' },
  {
    code: 'PM',
    label: 'Saint Pierre and Miquelon',
    phone: '508',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'PN', label: 'Pitcairn', phone: '870', isInEU: false, riskLevel: 'LOW' },
  { code: 'PR', label: 'Puerto Rico', phone: '1', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'PS',
    label: 'Palestine, State of',
    phone: '970',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'PT', label: 'Portugal', phone: '351', isInEU: true, riskLevel: 'LOW' },
  { code: 'PW', label: 'Palau', phone: '680', isInEU: false, riskLevel: 'LOW' },
  { code: 'PY', label: 'Paraguay', phone: '595', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'QA', label: 'Qatar', phone: '974', isInEU: false, riskLevel: 'LOW' },
  { code: 'RE', label: 'Reunion', phone: '262', isInEU: false, riskLevel: 'LOW' },
  { code: 'RO', label: 'Romania', phone: '40', isInEU: true, riskLevel: 'LOW' },
  { code: 'RS', label: 'Serbia', phone: '381', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'RU',
    label: 'Russian Federation',
    phone: '7',
    isInEU: false,
    riskLevel: 'HIGH',
  },
  { code: 'RW', label: 'Rwanda', phone: '250', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'SA',
    label: 'Saudi Arabia',
    phone: '966',
    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'SB',
    label: 'Solomon Islands',
    phone: '677',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'SC', label: 'Seychelles', phone: '248', isInEU: false, riskLevel: 'LOW' },
  { code: 'SD', label: 'Sudan', phone: '249', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'SE', label: 'Sweden', phone: '46', isInEU: true, riskLevel: 'LOW' },
  { code: 'SG', label: 'Singapore', phone: '65', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'SH',
    label: 'Saint Helena',
    phone: '290',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'SI', label: 'Slovenia', phone: '386', isInEU: true, riskLevel: 'LOW' },
  {
    code: 'SJ',
    label: 'Svalbard and Jan Mayen',
    phone: '47',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'SK', label: 'Slovakia', phone: '421', isInEU: true, riskLevel: 'LOW' },
  {
    code: 'SL',
    label: 'Sierra Leone',
    phone: '232',
    isInEU: false,
    riskLevel: 'MEDIUM',
  },
  { code: 'SM', label: 'San Marino', phone: '378', isInEU: false, riskLevel: 'LOW' },
  { code: 'SN', label: 'Senegal', phone: '221', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'SO', label: 'Somalia', phone: '252', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'SR', label: 'Suriname', phone: '597', isInEU: false, riskLevel: 'LOW' },
  { code: 'SS', label: 'South Sudan', phone: '211', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'ST',
    label: 'Sao Tome and Principe',
    phone: '239',
    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'SV',
    label: 'El Salvador',
    phone: '503',
    isInEU: false,
    riskLevel: 'MEDIUM',
  },
  {
    code: 'SX',
    label: 'Sint Maarten (Dutch part)',
    phone: '1-721',
    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'SY',
    label: 'Syrian Arab Republic',
    phone: '963',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'SZ', label: 'Swaziland', phone: '268', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'TC',
    label: 'Turks and Caicos Islands',
    phone: '1-649',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'TD', label: 'Chad', phone: '235', isInEU: false, riskLevel: 'MEDIUM' },
  {
    code: 'TF',
    label: 'French Southern Territories',
    phone: '262',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'TG', label: 'Togo', phone: '228', isInEU: false, riskLevel: 'LOW' },
  { code: 'TH', label: 'Thailand', phone: '66', isInEU: false, riskLevel: 'LOW' },
  { code: 'TJ', label: 'Tajikistan', phone: '992', isInEU: false, riskLevel: 'LOW' },
  { code: 'TK', label: 'Tokelau', phone: '690', isInEU: false, riskLevel: 'LOW' },
  { code: 'TL', label: 'Timor-Leste', phone: '670', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'TM',
    label: 'Turkmenistan',
    phone: '993',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'TN', label: 'Tunisia', phone: '216', isInEU: false, riskLevel: 'LOW' },
  { code: 'TO', label: 'Tonga', phone: '676', isInEU: false, riskLevel: 'LOW' },
  { code: 'TR', label: 'Turkey', phone: '90', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'TT',
    label: 'Trinidad and Tobago',
    phone: '1-868',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'TV', label: 'Tuvalu', phone: '688', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'TW',
    label: 'Taiwan, Province of China',
    phone: '886',
    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'TZ',
    label: 'United Republic of Tanzania',
    phone: '255',
    isInEU: false,
    riskLevel: 'MEDIUM',
  },
  { code: 'UA', label: 'Ukraine', phone: '380', isInEU: false, riskLevel: 'LOW' },
  { code: 'UG', label: 'Uganda', phone: '256', isInEU: false, riskLevel: 'MEDIUM' },
  {
    code: 'US',
    label: 'United States',
    phone: '1',

    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'UY', label: 'Uruguay', phone: '598', isInEU: false, riskLevel: 'LOW' },
  { code: 'UZ', label: 'Uzbekistan', phone: '998', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'VA',
    label: 'Holy See (Vatican City State)',
    phone: '379',
    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'VC',
    label: 'Saint Vincent and the Grenadines',
    phone: '1-784',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'VE', label: 'Venezuela', phone: '58', isInEU: false, riskLevel: 'MEDIUM' },
  {
    code: 'VG',
    label: 'British Virgin Islands',
    phone: '1-284',
    isInEU: false,
    riskLevel: 'LOW',
  },
  {
    code: 'VI',
    label: 'US Virgin Islands',
    phone: '1-340',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'VN', label: 'Vietnam', phone: '84', isInEU: false, riskLevel: 'LOW' },
  { code: 'VU', label: 'Vanuatu', phone: '678', isInEU: false, riskLevel: 'LOW' },
  {
    code: 'WF',
    label: 'Wallis and Futuna',
    phone: '681',
    isInEU: false,
    riskLevel: 'LOW',
  },
  { code: 'WS', label: 'Samoa', phone: '685', isInEU: false, riskLevel: 'LOW' },
  { code: 'XK', label: 'Kosovo', phone: '383', isInEU: false, riskLevel: 'LOW' },
  { code: 'YE', label: 'Yemen', phone: '967', isInEU: false, riskLevel: 'LOW' },
  { code: 'YT', label: 'Mayotte', phone: '262', isInEU: false, riskLevel: 'LOW' },
  { code: 'ZA', label: 'South Africa', phone: '27', isInEU: false, riskLevel: 'LOW' },
  { code: 'ZM', label: 'Zambia', phone: '260', isInEU: false, riskLevel: 'MEDIUM' },
  { code: 'ZW', label: 'Zimbabwe', phone: '263', isInEU: false, riskLevel: 'MEDIUM' },
];
